const workspaceLoadingService = {
    async fetchWorkspace(workspaceId: string) {
        return require(`../../docs/workspace/${workspaceId}.json`);
    },
};

export default workspaceLoadingService;
